import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Grid, ShimmerTypography, Space } from '@pitchero/react-ui';
import ProfilePlaceholder from './profile-placeholder';

const SquadLoadingState = ({ placeholdersLimit }) => {
  const renderPlaceholders = () => {
    const placeholders = [];

    for (let i = 1; i <= placeholdersLimit; i += 1) {
      placeholders.push(
        <Cushion all="medium" component="div">
          <ProfilePlaceholder key={i} />
        </Cushion>,
      );
    }

    return placeholders;
  };

  return (
    <Space bottom="xxlarge" component="div">
      <Space bottom="medium" component="div">
        <ShimmerTypography preset="title" width="25%" />
      </Space>
      <Grid
        columns="repeat(auto-fill, minmax(240px, 400px))"
        columnGap={24}
        rowGap={24}
        responsive={[{ maxWidth: 'palm', props: { rowGap: 12 } }]}
      >
        {renderPlaceholders()}
      </Grid>
    </Space>
  );
};

SquadLoadingState.defaultProps = {
  placeholdersLimit: 15,
};

SquadLoadingState.propTypes = {
  placeholdersLimit: PropTypes.number,
};

export default SquadLoadingState;
